import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  seriesBodyStylePipeline,
  seriesBodyStyleDescription,
} from 'reducers/seriesPipeline/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps } from 'utils/recompose';

const mapStateToProps = combineSelectors({
  seriesBodyStyleDescription,
  seriesBodyStylePipeline,
});

export const bodyStylePipeline = ({
  bodyStyleId,
  mini,
  seriesBodyStyleDescription,
  seriesBodyStylePipeline,
}) => {
  let name;
  if (mini) {
    name = `${bodyStyleId} - ${seriesBodyStyleDescription}`;
  } else {
    name = seriesBodyStyleDescription;
  }
  const data = {
    name: name,
    dealerInventory: seriesBodyStylePipeline.dealerInventory.quantity,
    processingCenter: seriesBodyStylePipeline.processingCenter.quantity,
    inTransitToVPS: seriesBodyStylePipeline.transitToVPS.quantity,
    scheduledInProduction: seriesBodyStylePipeline.scheduled.quantity,
    producedNotShipped: seriesBodyStylePipeline.producedNotShipped.quantity,
    onOrder: seriesBodyStylePipeline.onOrder.quantity,
    unsubmitted: seriesBodyStylePipeline.unsubmitted.quantity,
    projectedPipeline: seriesBodyStylePipeline.projectedPipeline.quantity,
  };
  return data;
};

export default compose(
  connect(mapStateToProps),
  addProps({ bodyStylePipeline }),
);
